// extracted by mini-css-extract-plugin
export default {"root":"Toolbar_root__tzU+4"};